import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserData } from 'src/app/models/user-data-model/user-data.model';
import { CompanyData } from 'src/app/models/company-data-model/company-data.model';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';
import { EMPTY, Subscription } from 'rxjs';
import { UserService } from 'src/app/services/user-service/user.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { RolesService } from 'src/app/services/roles-service/roles.service';
import { ContextsContextsService } from 'src/app/services/contexts-services/contexts-contexts-services/contexts-contexts.service';
import { EventsService } from 'src/app/services/events-service/events.service';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { SmsService } from 'src/app/services/sms-service/smsservice';
import { tap } from 'rxjs/internal/operators/tap';
import { catchError } from 'rxjs/internal/operators';
import { LicensesService } from 'src/app/services/licenses-service/licenses.service';

@Component({
  selector: 'app-account-dashboard',
  templateUrl: './account-dashboard.component.html',
  styleUrls: ['./account-dashboard.component.scss']
})
export class AccountDashboardComponent implements OnInit, OnDestroy {

  user;
  users;
  roles;
  contextsCounts;
  alertsCounts;
  ticketsCounts;
  smssCounts;
  licensesCount;
  userData: UserData;
  centerList: CenterLite[];
  companyData: CompanyData;
  getUserInfoSubscription: Subscription;
  getuserInfoSubscriptionRefresh: Subscription;
  getUsersSubscription: Subscription;
  getRoleListSubscription: Subscription;
  getContextsCounterSubscription: Subscription;
  getAlertsSubscription: Subscription;
  getGatewaysSubscription: Subscription;
  getTicketsSubscription: Subscription;
  getSMSsSubscription: Subscription;
  getLicensesSubscription: Subscription;

  constructor(private userStorageService: UserStorageService,
              private userService: UserService,
              private snackbarService: SnackBarService,
              private rolesService: RolesService,
              private contextsService: ContextsContextsService,
              private headerBreadcrumbService: HeaderBreadcrumbService,
              private ticketsService: TicketsService,
              private smsService: SmsService,
              private eventsService: EventsService,
              private licensesService: LicensesService) { }

  ngOnInit() {
    this.userData = this.userStorageService.getUserData();
    this.centerList = this.userStorageService.getCenterList();
    this.companyData = this.userStorageService.getCompanyData();
    this.setBreadcrumb();
    this.getUserInfo();
    this.getUsers();
    this.getRolesList();
    this.getContextsCounter();
    this.getAlertsCounter();
    this.getTicketsCounter();
    this.getSmsCounter();
    this.getLicenses();
    this.getuserInfoSubscriptionRefresh = this.userService.refreshUserListen().subscribe(
      (res) => {
        this.getUserInfo();
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getUserInfo() {
    this.getUserInfoSubscription = this.userService.getUserInfo(this.userData.InternalId).subscribe(
      (res) => {
          this.user = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  public getUsers() {
    this.getUsersSubscription = this.userService.getUsers().subscribe(
      (res) => {
        this.users = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getRolesList() {
    this.getRoleListSubscription = this.rolesService.getRolesList().subscribe(
      (res) => {
        this.roles = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getTicketsCounter() {
    this.getTicketsSubscription = this.ticketsService.getTicketCounter().subscribe(
      (res) => {
          this.ticketsCounts = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getSmsCounter() {
    this.getSMSsSubscription = this.smsService.getSmsCounter().subscribe(
      (res) => {
        this.smssCounts = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getLicenses() {
    this.getLicensesSubscription = this.licensesService.getLicenses().subscribe(
      (res) => {
        this.licensesCount = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getContextsCounter() {
    this.getContextsCounterSubscription = this.contextsService.getContextsCounter().pipe(
      tap(o => this.contextsCounts = o),
      catchError(error => {
        this.snackbarService.open(error['error']['message'], 'error');
        return EMPTY;
      })
    ).subscribe();
  }

  private getAlertsCounter() {
    this.getAlertsSubscription = this.eventsService.getAlertsCounter().pipe(
      tap(o => this.alertsCounts = o),
      catchError(error => { this.snackbarService.open(error['error']['message'], 'error'); return EMPTY; })
    ).subscribe();
  }

  public accessGranted(accessToken) {
    return this.userService.accessGranted(accessToken);
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-user-circle', 'account-page.account'));
  }

  ngOnDestroy() {
    if (this.getUserInfoSubscription) { this.getUserInfoSubscription.unsubscribe(); }
    if (this.getuserInfoSubscriptionRefresh) { this.getuserInfoSubscriptionRefresh.unsubscribe(); }
    if (this.getUsersSubscription) { this.getUsersSubscription.unsubscribe(); }
    if (this.getContextsCounterSubscription) { this.getContextsCounterSubscription.unsubscribe(); }
    if (this.getAlertsSubscription) { this.getAlertsSubscription.unsubscribe(); }
    if (this.getSMSsSubscription) { this.getSMSsSubscription.unsubscribe(); }
  }
}
